import * as React from 'react';

import { Deal } from '../../../../api/offer';

import { subscribeForUpdates } from '../../../../api/subscribe';
import SubscriptionForm from '../../../common/components/subscription_form/index';

interface IBSCSerpSubscriptionForm {
  dealType: Deal;
  qs: string;
}

const BSCSerpSubscriptionForm: React.SFC<IBSCSerpSubscriptionForm> = ({dealType, qs}) => {
  return (
    <SubscriptionForm
      onSubmit={(email: string) => subscribeForUpdates(email, dealType, qs)}
      formStyle={{
        marginTop: '8px',
        minHeight: '40px',
      }}
      inputStyle={{
        width: '220px',
      }}
    />
  );
};

export { IBSCSerpSubscriptionForm }
export default BSCSerpSubscriptionForm;



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/components/bsc_serp_subscription_form/bsc_serp_subscription_form.tsx